import React from 'react';
import './PageStyles.css';

const HomePage = () => {
  return (
    <div className="page-root">
      <main className="page-content" role="main">
        <div className="top-slogan-container">
            {/* badge-row（登録不要など）を削除 */}
          <p className="home-slogan-title" style={{marginTop: '1.2em'}}>Linux,Git,SQLコマンドは、<br/>遊んで覚えよう！</p>
          {/* リード文を一時的に削除（下に移動） */}
            <div className="home-ctas home-ctas--top">
            <a href="/play" className="page-cta page-cta--primary">今すぐ１分でプレイ</a>
            <a href="/how-to" className="page-cta page-cta--muted">遊び方を見る</a>
          </div>
        </div>
        <section className="hero-outer">
          <div className="hero-grid">
            <div className="hero-left">
            </div>

            <div className="hero-right" aria-hidden>
              {/* Use PUBLIC URL to ensure correct base path when app is hosted on a subpath */}
              <video
                className="hero-video"
                src={(process.env.PUBLIC_URL || '') + '/game-demo.mp4'}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                動画を再生できないブラウザです。
              </video>
            </div>
          </div>
          {/* キャプチャ動画の直下にリード文を移動 */}
          <div className="home-slogan-sub" style={{textAlign: 'center', marginTop: '2rem'}}>
            ガーリックハムスターは、Linux・Git・SQLコマンドをゲーム感覚で学べる、<br/>
            新感覚のスロットバトル式コマンド学習サイトです。<br/>
            １、２分でプレイ可能なので、スキマ時間で楽しく学習できます。<br/>
            さあ、お題に合うコマンドを揃えてモンスターを倒そう！
          </div>
        </section>

        

        <h3 className="home-section-title">特長</h3>

        <section className="home-features">
          <div className="feature">
            <div className="feature-icon">📚</div>
            <div>
              <h4>搭載コマンド充実</h4>
              <p>Linux 60+、Git 31、SQL 20+ の合計110以上のコマンドとそのオプションを学習できます。</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon">⚡</div>
            <div>
              <h4>短時間セッション</h4>
              <p>1回あたり数分から遊べる設計で継続しやすい。</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon feature-icon--check" aria-hidden>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
                <path d="M20 6L9 17l-5-5" stroke="white" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <h4>登録不要</h4>
              <p>ブラウザでアクセスするだけですぐにプレイできます。</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon">😊</div>
            <div>
              <h4>完全無料</h4>
              <p>全ての機能を無料でご利用いただけます。</p>
            </div>
          </div>

          <div className="feature">
            <div className="feature-icon feature-icon--warm">❤</div>
            <div>
              <h4>快適プレイ機能</h4>
              <p>色覚サポートモード、低刺激モード、キーボード操作に対応。</p>
            </div>
          </div>

          {/* 右下の空きスペース用: KWSKプロモ */}
          <div className="feature feature-kwsk">
            <div className="feature-icon feature-icon--kwsk">🤖</div>
            <div>
              <h4>放置モード搭載</h4>
              <p>操作不要の放置モードで、ショート動画感覚で学習できる！</p>
            </div>
          </div>
        </section>

        <section className="recommended-env">
          <h3>推奨環境</h3>
          <ul>
            <li>推奨ブラウザ：最新版の Chrome、Edge、Firefox、Safari</li>
            <li>推奨画面サイズ：横幅 1024px 以上（モバイルにも対応）</li>
            <li>JavaScriptを有効にしてください</li>
            <li>音声を利用する場合はスピーカーまたはヘッドホンを接続してください</li>
          </ul>
        </section>

        
      </main>
    </div>
  );
};

export default HomePage;
